/**
 * @description Utilities class for working with geometry
 */

import { isDefined } from "@utils/var.check";

const GeometryUtils = {
  /**
   * @summary Converts a degree to radian form to be used for cartesian equations
   * @param {Number} deg - The degree of the specified angle
   * @returns {Number} - The radian of the specific angle
   * @example
   * GeometryUtils.degreeToRadian(90) => 1.57
   */
  degreeToRadian: (deg) => {
    if (!isDefined) {
      return 0;
    }

    return (deg * Math.PI) / 180;
  },
};

export default GeometryUtils;
